import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import BllinkUtils from '../../../../common/utils/utils';
import Checkbox from '../../../../common/simple/Checkbox';
import { ActionsCardWrapper } from '../BankAdjustmentsNew.styled';
import {Currency} from "../../../../common/currency";

export const BankCard = ({ date, confirmationId, currency = 'ils', description, type, creditOrDebitNum, paymentMethod }) => {
    const { t } = useTranslation();

    const ltr = useSelector(state => state.common.ltrEnabled);

    const parsedDate = BllinkUtils.BllinkTime.parseDate(date);
 
    return (
        <ActionsCardWrapper bank ltr={ltr}>
            <div className='actions-header'>
                <div>
                    {t('expenses.date')}:
                    <span>{parsedDate}</span>
                </div>
                <div>
                    {t('offline_payments.amount')}:
                    <span>{creditOrDebitNum} <Currency>{currency}</Currency></span>
                </div>
            </div>
            <div className='info-wrapper'>
                <div className='info-container'>
                    <span>{t('expenses.type')}</span>
                    <span className='info-span'>{type}</span>
                </div>

                <div className='info-container'>
                    <span>{t('expenses.bank_adjustments.document_number')}</span>
                    <span className='info-span'>{confirmationId}</span>
                </div>

                <div className='info-container'>
                    <span>{t('expenses.payment_method')}</span>
                    <span className='info-span'>{paymentMethod}</span>
                </div>

                <div className='info-container'>
                    <span>{t('expenses.bank_adjustments.description')}</span>
                    <OverlayTrigger
                            placement="top"
                            overlay={props => (
                                <Tooltip {...props}>
                                    <div>{description}</div>
                                </Tooltip>
                            )}
                    >
                        <span className='info-span description'>{description}</span>                     
                    </OverlayTrigger>
                </div>
            </div>
        </ActionsCardWrapper>
    );
};

const BankActionsCard = ({ date, description, type, creditOrDebitNum, confirmationId, paymentMethod, checked = false, onChange }) => {
    const [checkedState, setCheckedState] = useState(checked);

    const onCheckboxChange = () => {
        onChange(confirmationId, !checkedState)
        setCheckedState(!checkedState);
    };

    return (
        <div className='action-with-checkbox'>
            <Checkbox 
                checked={checkedState}
                onChange={onCheckboxChange}
                className='check'
                fullWidthLabel
                size={20}
                label={<BankCard 
                    date={date}
                    confirmationId={confirmationId}
                    description={description}
                    type={type}
                    creditOrDebitNum={creditOrDebitNum}
                    paymentMethod={paymentMethod}
                />}
            />        
        </div>
    );
};

export default BankActionsCard;
